import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import {
  CobaltButtonModule,
  ContentModalComponent,
  ContentModalTitleDirective,
  MsiContentModalRef,
} from '@msi/cobalt-prime';
import { IconComponent } from '@msi/cobalt-prime';
import { VerifyResult } from '@geocode-models/verify-result.model';
import { EmptyTextPipe } from '@app/pipes/empty-text.pipe';

export interface SelectGeocodedAddressModalData {
  matchedLocations: VerifyResult[];
}

@Component({
  selector: 'app-select-geocoded-address-modal',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoDirective,
    TranslocoPipe,
    ContentModalComponent,
    ContentModalTitleDirective,
    CobaltButtonModule,
    IconComponent,
    EmptyTextPipe,
  ],
  templateUrl: './select-geocoded-address-modal.component.html',
  styleUrls: ['./select-geocoded-address-modal.component.scss'],
})
export class SelectGeocodedAddressModalComponent {
  public readonly modalRef = inject<MsiContentModalRef<SelectGeocodedAddressModalData, number>>(MsiContentModalRef);
  public readonly matchedLocations: VerifyResult[] = this.modalRef.getData()?.matchedLocations ?? [];
}
